import script from "./PrivacyPolicyAndTerms.vue?vue&type=script&setup=true&lang=js"
export * from "./PrivacyPolicyAndTerms.vue?vue&type=script&setup=true&lang=js"

import "./PrivacyPolicyAndTerms.vue?vue&type=style&index=0&id=34ab800d&lang=scss&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/h5-subscription-client-prod-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-34ab800d"]])

export default __exports__